/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TableInGoldStandardsTables model module.
 * @module model/TableInGoldStandardsTables
 * @version 2.8.0
 */
class TableInGoldStandardsTables {
    /**
     * Constructs a new <code>TableInGoldStandardsTables</code>.
     * @alias module:model/TableInGoldStandardsTables
     * @param name {String} 
     * @param files {Array.<String>} 
     */
    constructor(name, files) { 
        
        TableInGoldStandardsTables.initialize(this, name, files);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, files) { 
        obj['name'] = name;
        obj['files'] = files;
    }

    /**
     * Constructs a <code>TableInGoldStandardsTables</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TableInGoldStandardsTables} obj Optional instance to populate.
     * @return {module:model/TableInGoldStandardsTables} The populated <code>TableInGoldStandardsTables</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TableInGoldStandardsTables();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('files')) {
                obj['files'] = ApiClient.convertToType(data['files'], ['String']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
TableInGoldStandardsTables.prototype['name'] = undefined;

/**
 * @member {Array.<String>} files
 */
TableInGoldStandardsTables.prototype['files'] = undefined;






export default TableInGoldStandardsTables;

